import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { API_URL, config, UserCode } from '../../components/Include'
import { useSelector } from 'react-redux'
import { Alerts } from '../../components/notify'
import { getBritishDate } from '../../components/GlobalFunction'
import './dashboard.css'

const Dashboard = () => {
  // State management
  const [loading, setLoading] = useState(false)
  const [recentActivities, setRecentActivities] = useState<any[]>([])
  
  // Get student data from Redux store
  const student = useSelector((state: any) => state.rootReducer.student)

  useEffect(() => {
    fetchDashboardData()
  }, [])


  const [content, setContent] = useState([] as any)


  const FetchSchedule = () => {
    setLoading(true);
    const url = API_URL + '/student/course_record/' + UserCode
    
    axios.get(url, config)
      .then((response:any) => {

        if (response.data.status === 200) {
          setContent(response.data.data);
        }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
      });
  };



  // Fetch all dashboard data
  const fetchDashboardData = async () => {
    setLoading(true)
    try {
      
      // Mock recent activities
      setRecentActivities([
        {
          id: 'act1',
          type: 'course_registration',
          title: 'Registered for Entrepreneurship Skills',
          date: '2025-06-01T15:30:00',
          details: 'Course Code: ENT301'
        },
        {
          id: 'act2',
          type: 'certificate_request',
          title: 'Requested Certificate for Data Science',
          date: '2025-05-28T11:20:00',
          details: 'Status: Processing'
        },
        {
          id: 'act3',
          type: 'skill_change',
          title: 'Changed skill from Graphics Design to Web Development',
          date: '2025-05-25T09:45:00',
          details: 'Approved by Administrator'
        }
      ])

     
    } catch (error: any) {
      Alerts('danger', error.message, 'Error fetching dashboard data')
    } finally {
      setLoading(false)
    }
  }

  // Helper function to get icon for activity type
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'course_registration':
        return 'fa-book'
      case 'certificate_request':
        return 'fa-certificate'
      case 'skill_change':
        return 'fa-refresh'
      case 'complaint':
        return 'fa-exclamation-triangle'
      default:
        return 'fa-list'
    }
  }


 

  useEffect(()=>{
    FetchSchedule();
  },[])

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="dashboard-container">
      

        <div className="dashboard-content">
         

          {/* Quick Actions */}
          <div className="quick-actions">
            <h5 className="section-title"><i className="fa fa-flash"></i> Quick Actions</h5>
            <div className="actions-container">
              <Link to="/app/skills" className="action-card">
                <div className="action-icon">
                  <i className="fa fa-plus-circle"></i>
                </div>
                <span>Register Course</span>
              </Link>
              
              <Link to="/app/portal/change-skill" className="action-card">
                <div className="action-icon">
                  <i className="fa fa-refresh"></i>
                </div>
                <span>Change of Skill</span>
              </Link>
              
              <Link to="/app/portal/certificate" className="action-card">
                <div className="action-icon">
                  <i className="fa fa-certificate"></i>
                </div>
                <span>Request Certificate</span>
              </Link>

              <Link to="/app/portal/complaints" className="action-card">
                <div className="action-icon">
                  <i className="fa fa-exclamation-circle"></i>
                </div>
                <span>Drop Complaint</span>
              </Link>
            </div>
          </div>

          {/* Course Registration History */}
          <div className="course-history-section">
            <h5 className="section-title"><i className="fa fa-history"></i> Course Registration History</h5>
            
            {content && content.length > 0 ? (
              <>
                {/* Desktop Table View */}
                <div className="course-history-table desktop-view">
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead className="table-header">
                        <tr>
                          <th>Code</th>
                          <th>Course Title</th>
                          <th>Skill</th>
                          <th>Payment Ref</th>
                          <th>Registration Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {content.map((item:any, id:number) => (
                          <tr key={id}>
                            <td className="course-code">{item.course_code}</td>
                            <td className="course-name">
                              <i className="fa fa-book course-icon"></i>
                              <span>{item.course_title}</span>
                            </td>
                            <td className="course-status">
                              {item.title}
                            </td>
                            <td className="instructor-name">{item.payment_ref}</td>
                            <td className="registration-date">
                              {getBritishDate(item.date_paid)}
                            </td>
                            <td className="course-action">
                              <a href={`/app/get_printout/${item.code}`} className="btn btn-sm btn-outline-primary">
                                <i className="fa fa-print"></i> Preview
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Mobile Card View */}
                <div className="course-history-cards mobile-view">
                  {content.map((item:any, id:number) => (
                    <div key={id} className="course-card">
                      <div className="course-card-header">
                        <div className="course-card-code">{item.course_code}</div>
                        <a href={`/app/get_printout/${item.code}`} className="btn btn-sm btn-primary">
                          <i className="fa fa-download"></i> Preview
                        </a>
                      </div>
                      <div className="course-card-body">
                        <div className="course-card-title">
                          <i className="fa fa-book"></i>
                          <span>{item.course_title}</span>
                        </div>
                        <div className="course-card-info">
                          <div className="info-row">
                            <span className="info-label"><i className="fa fa-wrench"></i> Skill:</span>
                            <span className="info-value">{item.title}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label"><i className="fa fa-credit-card"></i> Payment Ref:</span>
                            <span className="info-value">{item.payment_ref}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label"><i className="fa fa-calendar"></i> Date:</span>
                            <span className="info-value">{getBritishDate(item.date_paid)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="empty-state">
                <i className="fa fa-inbox"></i>
                <p>No course registration history found</p>
              </div>
            )}
          </div>

          {/* Main Dashboard Grid */}
          <div className="dashboard-grid">
          

           

            {/* Recent Activities */}
            <div className="dashboard-card activities-card">
              <div className="card-header">
                <h5><i className="fa fa-history"></i> Recent Activities</h5>
              </div>
              <div className="card-body">
                {recentActivities.length > 0 ? (
                  <div className="activities-list">
                    {recentActivities.map(activity => (
                      <div key={activity.id} className="activity-item">
                        <div className="activity-icon">
                          <i className={`fa ${getActivityIcon(activity.type)}`}></i>
                        </div>
                        <div className="activity-content">
                          <h6 className="activity-title">{activity.title}</h6>
                          <p className="activity-details">{activity.details}</p>
                          <div className="activity-date">
                            <i className="fa fa-calendar"></i>
                            {getBritishDate(activity.date)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <i className="fa fa-history"></i>
                    <p>No recent activities</p>
                  </div>
                )}
              </div>
            </div>

            {/* Student Information */}
            <div className="dashboard-card student-info-card">
              <div className="card-header">
                <h5><i className="fa fa-id-card-o"></i> Student Information</h5>
              </div>
              <div className="card-body">
                <div className="student-profile">
                  <div className="student-avatar">
                    <i className={`fa fa-${student?.gender === 'male' ? 'male' : 'female'}`}></i>
                  </div>
                  <div className="student-details">
                    <h6>{student?.surname} {student?.firstname}</h6>
                    <p className="student-id"><i className="fa fa-id-card-o"></i> {student?.matric_no || 'Student ID'}</p>
                  </div>
                </div>
                
                <div className="info-list">
                  <div className="info-item">
                    <span className="info-label"><i className="fa fa-building"></i> Department:</span>
                    <span className="info-value">{student?.department || 'Not available'}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label"><i className="fa fa-graduation-cap"></i> Level:</span>
                    <span className="info-value">{student?.level || 'Not available'}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label"><i className="fa fa-envelope"></i> Email:</span>
                    <span className="info-value">{student?.email_address || 'Not available'}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label"><i className="fa fa-phone"></i> Phone:</span>
                    <span className="info-value">{student?.telephone || 'Not available'}</span>
                  </div>
                </div>
                
                <Link to="/app/profile" className="btn-edit-profile">
                  <i className="fa fa-pencil"></i> Edit Profile
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard